<template>
  <div class="info-overlay hide-for-print">
    <div class="inner" v-html="description"></div>
  </div><!-- /.info-overlay -->
</template>

<script>
export default {
  name: 'info-overlay',
  props: {
    'description': {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .info-overlay{
    bottom: 0;
    background: transparentize($white, 0.3);
    display: flex; -js-display: flex;
    justify-content: center;
    left: 0;
    min-height: 300px;
    padding-top: 200px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 150;

    .inner{
      color: $gray;
      font: 100 28px/1.4 $fontfamily-serif;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/InfoOverlay.vue